export const new_202010 = [
    "Coolman",
    "Sun",
    "Phoenix",
    "Pro",
    "Platinum",
    "Royal",
    "Globe",
    "Trojan",
    "Tropical",
    "Crown",
    "Galaxy",
    "Gold",
    "Medal",
    "Infinity",
    "Jaguar",
    "Jazz",
    "Legend",
    "Panther",
    "Silver",
    "Sky",
    "Ollie",
    "Minion",
    "Everest",
    "Unify",
    "Unicorn",
    "Lullaby",

    "Star",
    "Ben",
    "Ten",
    "Red",
    "Net",
    "Cup",
    "Win",
    "Rock",
    "Wish",
    "Viet",
    "Way",
    "Men",
    "Wing",
    "Spring",
    "Boy",
    "Box",
    "Fun",
    "Strong",
    "Ken",
    "Mar",
    "Smart",
    "Strength",
    "Red",
    "Blue",
    "Black",
    "Sand",
    "Snow",
    "Best",
    "Gift",
    "Bat",
    "Earth",
    "Play",
    "Car",
    "Truck",
    "Vin",
    "Max",
    "Fox",
    "Grow",
    "Top",
    "Vip",
    "Joy",
    "Path",
    "Glow",
    "North",
    "South",
    "West",
    "East",
    "Cool",
    "Hot",
    "Nick",
    "Storm",
    "Pal",
    "Kind",
    "Wild",
    "Run",
    "Mac",
    "Club",
    "Brown",
    "Van",
    "Love",
    "Gun",
    "One",
    "You",
    "Heart",
    "Ace",
    "Time",
    "Bee",
    "Sea",
    "Luck",
    "Fight",
    "Bright",
    "Rain",
    "Moon",
    "Smile",
    "Neo",
    "Friend",
    "Belle",
    "Lune",
    "Real",
    "Lucky",
    "Perfect",
    "Silver",
    "Apple",
    "Iron",
    "Monster",
    "River",
    "Money",
    "Circle",
    "Santa",
    "Energy",
    "Power",
    "Hero",
    "Winter",
    "Forest",
    "Pasta",
    "Happy",
    "Simple",
    "Pumpkin",
    "Basic",
    "Combat",
    "Panda",
    "Tender",
    "Roman",
    "Fancy",
    "Hello",
    "Arrow",
    "Atom",
    "Nation",
    "Pilot",
    "Radar",
    "Coffee",
    "Dragon",
    "Soda",
    "Coca",
    "Robot",
    "Super",
    "Magic",
    "Target",
    "Zero",
    "Mayo",
    "Planet",
    "System",
    "Central",
    "Fossil",
    "Crystal",
    "Motion",
    "Mobile",
    "Success",
    "Rocket",
    "Comet",
    "Scooter",
    "Lizard",
    "Sheriff",
    "Honey",
    "Copy",
    "Enjoy",
    "Lighter",
    "Cherry",
    "Captain",
    "Phonic",
    "Lingo",
    "Robust",
    "Vista",
    "Lucid",
    "Matrix",
    "Nomic",
    "Visage",
    "Superb",
    "Excel",
    "Penta",
    "Lumi",
    "Arcade",
    "Canto",
    "Polar",
    "Forte",
    "Solar",
    "Lagoon",
    "Heaven",
    "Wonder",
    "Silky",

    "Linux",
    "Android",
    "Window",
    "Nokia",
    "Honda",
    "Optima",
    "Samsung",
    "BMW",
    "Disney",
    "Intel",
    "Facebook",
    "Cisco",
    "Oracle",
    "Nike",
    "Pepsi",
    "Barcelona",
    "Juventus",
    "Zara",
    "eBay",
    "Audi",
    "Canon",
    "Nissan",
    "Arsenal",
    "Porsche",
    "Gucci",
    "Sony",
    "adidas",
    "Visa",
    "Cartier",
    "Adobe",
    "Lego",
    "Prada",
    "Burberry",
    "Heineken",
    "Dior",
    "Shell",
    "Tesla",
    "Chelsea",
    "Manchester",

    "Ronaldo",
    "Messi",
    "Maradona",
    "Neymar",
    "Rooney",
    "Maldini",
    "Ronaldinho",
    "Xavi",
    "Iniesta",
    "Pele",
    "Suarez",
    "Zidane",
    "Trump",
    "Biden",
    "Figo",
    "Firlo",
    "Falcao",
    "Ferguson",
    "Gerrard",
    "Casillas",
    "Buffon",
    "Cavani",
    "Pogba",
    "Lampard",
    "Owen",
    "Ramos",
    "Ribery",
    "Benzema",
    "Bale",
    "Tevez",
    "Drogba",
    "Gomez",
    "Robben",
    "Balotelli",
    "Pedro",
    "Mourinho",
    "Forlan",
    "Agassi",
    "Sampras",
    "Djokovic",
    "Nadal",
    "Federer",
    "Tsonga"
];
